module.exports = __webpack_public_path__ + "static/img/new-user-event-banner.9927b7a.png";